/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable check-file/filename-naming-convention */
import * as React from 'react';
import type { SVGProps } from 'react';

export type IllustrationSizeVariants =
  | 'small'
  | 'medium'
  | 'large'
  | 'xlarge'
  | 'xxlarge'
  | 'xxxlarge'
  | 'xxxxlarge';
export type IllustrationProps = {
  width?: number | string;
  height?: number | string;
  size?: IllustrationSizeVariants;
};
const IllustrationStickerDiscover = ({
  size = 'medium',
  width,
  height,
  ...props
}: IllustrationProps) => {
  let presetWidth: string | undefined;
  let presetHeight: string | undefined;
  const presets = {
    small: '48px',
    medium: '68px',
    large: '92px',
    xlarge: '122px',
    xxlarge: '156px',
    xxxlarge: '194px',
    xxxxlarge: '236px',
  };
  if (size) {
    presetWidth = presets[size];
    presetHeight = presets[size];
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 68 68"
      data-xds="IllustrationStickerDiscover"
      height={height || presetHeight}
      role="presentation"
      width={width || presetWidth}
      {...props}
    >
      <path
        fill="var(--xdlColorIllustrationBackground)"
        fillRule="evenodd"
        d="m61.276 45.432-.922-3.416 5.614-10.403a14.8 14.8 0 0 0 .717-4.564c0-8.217-6.686-14.903-14.903-14.903-5.213 0-9.807 2.693-12.47 6.758l-.59.82c-2.561-4.522-7.416-7.582-12.973-7.582-4.008 0-7.65 1.594-10.332 4.178a4.53 4.53 0 0 1 2.086-2.516l2.973-1.65-2.973-1.652a4.55 4.55 0 0 1-2.169-2.765L13.514.971l-1.825 6.77a4.52 4.52 0 0 1-2.169 2.765l-2.973 1.65 2.973 1.652a4.53 4.53 0 0 1 2.165 2.765l.91 3.381-.155.393c-.412.812-.748 1.67-1.008 2.561l-7.62 19.358.034.434a15 15 0 0 0 .219 1.58L1.3 51.354l.034.43a13 13 0 0 0 .744 3.431l-.9 2.369.035.423a10.21 10.21 0 0 0 5.76 8.39c1.38.658 2.85.99 4.368.99 2.093 0 4.106-.63 5.825-1.828l.344-.238 1.266-2.176a13.4 13.4 0 0 0 3.154-1.61l.351-.245 3.74-6.581q.713-.388 1.387-.858l.25-.173c.12.525.267 1.038.449 1.54l-.9 2.37.035.423a10.21 10.21 0 0 0 5.76 8.39c1.38.657 2.85.99 4.368.99 2.093 0 4.106-.631 5.825-1.829l.344-.238 1.265-2.176a13.4 13.4 0 0 0 3.155-1.609l.351-.245 3.74-6.581c.476-.261.937-.544 1.387-.858l.355-.245 1.303-2.305.359.2a4.53 4.53 0 0 1 2.165 2.766l1.824 6.77 1.825-6.77a4.52 4.52 0 0 1 2.169-2.766l2.973-1.65-2.973-1.651a4.57 4.57 0 0 1-2.161-2.773"
        clipRule="evenodd"
      />
      <path
        fill="#FE813C"
        d="M16.588 12.157a6.42 6.42 0 0 0-3.075 3.925 6.38 6.38 0 0 0-3.075-3.925 6.42 6.42 0 0 0 3.075-3.925 6.38 6.38 0 0 0 3.075 3.925M62.526 49.848a6.42 6.42 0 0 0-3.075 3.925 6.38 6.38 0 0 0-3.075-3.925 6.42 6.42 0 0 0 3.075-3.925 6.4 6.4 0 0 0 3.075 3.925"
      />
      <path
        fill="#A456F6"
        fillRule="evenodd"
        d="M29.13 57.857a8.28 8.28 0 0 0 12.992 6.15l6.128-10.536-14.779-7.046z"
        clipRule="evenodd"
      />
      <path
        fill="#A456F6"
        fillRule="evenodd"
        d="M29.251 51.639c.306 3.872 2.61 7.483 6.37 9.274 3.777 1.802 8.057 1.303 11.265-.93l9.297-16.357-20.06-9.562z"
        clipRule="evenodd"
      />
      <path
        fill="#A456F6"
        fillRule="evenodd"
        d="M31.767 42.553c.355 4.526 3.049 8.742 7.439 10.835 4.416 2.104 9.414 1.522 13.161-1.085L63.538 32.55 40.105 21.38zM3.098 57.857a8.28 8.28 0 0 0 12.991 6.15l6.128-10.536-14.782-7.046z"
        clipRule="evenodd"
      />
      <path
        fill="#A456F6"
        fillRule="evenodd"
        d="M3.219 51.639c.306 3.872 2.61 7.483 6.369 9.274 3.778 1.802 8.058 1.303 11.265-.93l9.297-16.357-20.06-9.562z"
        clipRule="evenodd"
      />
      <path
        fill="#A456F6"
        fillRule="evenodd"
        d="M5.735 42.553c.355 4.526 3.048 8.742 7.438 10.835 4.416 2.104 9.414 1.522 13.162-1.085l11.17-19.754-23.433-11.174z"
        clipRule="evenodd"
      />
      <path
        fill="#fff"
        d="M51.782 40.063c7.188 0 13.015-5.827 13.015-13.014 0-7.188-5.827-13.015-13.015-13.015-7.187 0-13.014 5.827-13.014 13.015s5.826 13.014 13.014 13.014M25.753 40.064c7.188 0 13.015-5.828 13.015-13.015S32.94 14.035 25.753 14.035c-7.187 0-13.014 5.826-13.014 13.014s5.826 13.014 13.014 13.014"
      />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="m13.513 16.811-.181-.676a6.23 6.23 0 0 0-2.985-3.808l-.298-.166.298-.166a6.24 6.24 0 0 0 2.985-3.808l.181-.676.181.676c.435 1.609 1.523 3 2.985 3.808l.298.166-.298.166a6.25 6.25 0 0 0-2.984 3.808zm-2.7-4.654a6.64 6.64 0 0 1 2.7 3.306 6.64 6.64 0 0 1 2.701-3.306 6.64 6.64 0 0 1-2.7-3.305 6.62 6.62 0 0 1-2.702 3.305M59.451 54.498l-.181-.676a6.23 6.23 0 0 0-2.985-3.808l-.298-.166.298-.166a6.24 6.24 0 0 0 2.985-3.808l.181-.677.181.677c.435 1.61 1.523 3 2.985 3.808l.298.166-.298.166a6.24 6.24 0 0 0-2.984 3.808zm-2.7-4.65a6.64 6.64 0 0 1 2.7 3.306 6.62 6.62 0 0 1 2.701-3.306 6.64 6.64 0 0 1-2.7-3.306 6.64 6.64 0 0 1-2.702 3.306"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        d="M31.25 27.034a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0"
      />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="M25.753 31.155a11.62 11.62 0 0 1-8.764-3.997l-.11-.124.11-.125a11.6 11.6 0 0 1 4.653-3.245l-1.088-2.594.348-.146 1.095 2.612a11.6 11.6 0 0 1 3.567-.622v-2.77h.378v2.77c1.18.02 2.338.218 3.438.58l1.075-2.565.349.146-1.067 2.543a11.64 11.64 0 0 1 4.78 3.291l.11.125-.11.125a11.63 11.63 0 0 1-8.764 3.996m-8.371-4.121a11.24 11.24 0 0 0 8.367 3.744c3.193 0 6.238-1.364 8.368-3.744a11.24 11.24 0 0 0-8.368-3.744 11.23 11.23 0 0 0-8.367 3.744"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="M25.753 37.963c-6.018 0-10.914-4.896-10.914-10.914s4.896-10.914 10.914-10.914 10.914 4.896 10.914 10.914-4.896 10.914-10.914 10.914m0-21.45c-5.81 0-10.536 4.726-10.536 10.536s4.726 10.536 10.536 10.536S36.29 32.86 36.29 27.05s-4.726-10.536-10.537-10.536"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        d="M57.283 27.034a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0"
      />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="M43.022 27.159a11.62 11.62 0 0 0 8.764 3.996c3.358 0 6.55-1.458 8.764-3.997l.11-.124-.11-.125a11.64 11.64 0 0 0-4.781-3.29l1.066-2.544-.348-.146-1.076 2.565c-1.1-.362-2.257-.56-3.436-.58v-2.77h-.378v2.77c-1.226.02-2.428.233-3.565.622l-1.096-2.612-.348.146 1.088 2.594a11.6 11.6 0 0 0-4.654 3.245l-.11.125zm8.76 3.619a11.24 11.24 0 0 1-8.368-3.744 11.23 11.23 0 0 1 8.368-3.744c3.192 0 6.234 1.364 8.368 3.744a11.23 11.23 0 0 1-8.368 3.744"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="M40.872 27.05c0 6.017 4.896 10.913 10.914 10.913S62.7 33.067 62.7 27.05s-4.896-10.914-10.914-10.914-10.914 4.896-10.914 10.914m.378 0c0-5.811 4.726-10.537 10.536-10.537s10.536 4.726 10.536 10.536-4.726 10.536-10.536 10.536S41.25 32.86 41.25 27.05"
        clipRule="evenodd"
      />
      <path
        fill="#1D2124"
        fillRule="evenodd"
        d="M13.04 23.483 5.56 42.477l-.015.042.004.045q.075.956.283 1.878l-2.788 7.129-.015.041.004.042c.098 1.241.397 2.44.87 3.557l-.98 2.581-.015.042.004.041a8.5 8.5 0 0 0 4.798 6.99 8.5 8.5 0 0 0 3.638.82 8.53 8.53 0 0 0 4.858-1.523l1.416-2.428a11.5 11.5 0 0 0 3.34-1.591l3.818-6.702q.861-.43 1.664-.986l5.21-9.198q.078.597.21 1.179l-2.791 7.134-.015.042.004.041c.098 1.241.397 2.44.87 3.557l-.98 2.582-.015.042.004.041a8.49 8.49 0 0 0 4.797 6.99 8.487 8.487 0 0 0 8.492-.703l1.416-2.426a11.4 11.4 0 0 0 3.345-1.594l3.818-6.7a13 13 0 0 0 1.667-.991l10.03-17.703a13.13 13.13 0 0 0 2.482-7.699c0-7.28-5.923-13.203-13.203-13.203-6.04 0-11.147 4.078-12.71 9.626l-.38.962c-1.217-6.032-6.558-10.588-12.943-10.588-6.044 0-11.154 4.084-12.714 9.637m26.249 29.731A12.99 12.99 0 0 1 31.971 42.7l4.512-7.966a13.1 13.1 0 0 0 2.287-5.464c1.059 6.226 6.493 10.982 13.016 10.982 3.682 0 7.017-1.515 9.414-3.954L52.224 52.17a12.97 12.97 0 0 1-12.935 1.043m-26.74-26.165c0 7.28 5.924 13.203 13.204 13.203 3.682 0 7.017-1.515 9.414-3.954L26.19 52.17a12.97 12.97 0 0 1-12.935 1.043 12.99 12.99 0 0 1-7.329-10.635l6.709-17.039q-.086.743-.086 1.509m.379 0c0-7.072 5.753-12.826 12.825-12.826 7.068 0 12.826 5.754 12.826 12.826s-5.754 12.825-12.826 12.825-12.825-5.753-12.825-12.825M3.41 51.669l2.58-6.598a13.36 13.36 0 0 0 7.103 8.483 13.3 13.3 0 0 0 5.72 1.292c1.841 0 3.68-.381 5.387-1.133l-3.491 6.142a11.08 11.08 0 0 1-11.043.888 11.09 11.09 0 0 1-6.256-9.074m.712 4.026-.832 2.192a8.13 8.13 0 0 0 4.582 6.637 8.11 8.11 0 0 0 8.077-.646l1.17-2.01c-.887.214-1.795.322-2.704.322-1.674 0-3.35-.366-4.907-1.107a11.46 11.46 0 0 1-5.386-5.388m26.03.004-.83 2.188a8.12 8.12 0 0 0 4.583 6.637 8.11 8.11 0 0 0 8.077-.646l1.17-2.01a11.5 11.5 0 0 1-2.708.322c-1.673 0-3.35-.367-4.907-1.107a11.45 11.45 0 0 1-5.384-5.384m14.693-.853c1.842 0 3.681-.381 5.389-1.134l-3.492 6.143a11.08 11.08 0 0 1-11.043.888 11.09 11.09 0 0 1-6.256-9.074l2.58-6.598a13.36 13.36 0 0 0 7.103 8.483 13.3 13.3 0 0 0 5.72 1.292M38.96 27.049c0-7.072 5.754-12.826 12.826-12.826 7.068 0 12.826 5.754 12.826 12.826s-5.754 12.825-12.826 12.825S38.96 34.122 38.96 27.05"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default IllustrationStickerDiscover;
